import React from 'react';

interface AdminCardProps {
    title: string;
    description: string;
    icon: React.ReactNode;
    buttonText: string;
    onButtonClick?: () => void;
    buttonColor?: 'primary' | 'secondary' | 'warning' | 'error';
    borderColor?: string;
}

const AdminCard: React.FC<AdminCardProps> = ({
    title,
    description,
    icon,
    buttonText,
    onButtonClick,
    buttonColor = 'primary',
    borderColor
}) => {
    const cardClasses = borderColor 
        ? `tw-card tw-bg-base-100 tw-shadow-xl ${borderColor}`
        : 'tw-card tw-bg-base-100 tw-shadow-xl';

    const buttonClasses = `tw-btn tw-btn-${buttonColor}`;

    return (
        <div className={cardClasses}>
            <div className="tw-card-body">
                <h2 className={`tw-card-title tw-text-${buttonColor}`}>
                    {icon}
                    {title}
                </h2>
                <p>{description}</p>
                <div className="tw-card-actions tw-justify-end">
                    <button 
                        className={buttonClasses}
                        onClick={onButtonClick}
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminCard;

